var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 20.9998C16.5523 20.9998 17 20.5521 17 19.9998V5.36976L19.2408 7.98396C19.6002 8.40329 20.2315 8.45185 20.6508 8.09242C21.0702 7.73301 21.1187 7.1017 20.7592 6.68238L16.7592 2.01572C16.5694 1.79406 16.2919 1.6665 16 1.6665C15.7082 1.6665 15.4307 1.79406 15.2408 2.01572L11.2408 6.68238C10.8813 7.1017 10.9299 7.73301 11.3492 8.09242C11.7686 8.45185 12.3999 8.40329 12.7593 7.98396L15 5.36976V19.9998C15 20.5521 15.4478 20.9998 16 20.9998Z",
    fill: "#F9AA2A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.3327 12C20.3964 12 19.9283 12 19.592 12.2247C19.4464 12.322 19.3213 12.447 19.2241 12.5926C18.9993 12.9289 18.9993 13.3971 18.9993 14.3333V20C18.9993 21.6568 17.6563 23 15.9993 23C14.3425 23 12.9994 21.6568 12.9994 20V14.3333C12.9994 13.3971 12.9994 12.9289 12.7747 12.5925C12.6774 12.447 12.5524 12.322 12.4069 12.2247C12.0706 12 11.6024 12 10.666 12C6.89478 12 5.00916 12 3.83759 13.1716C2.66602 14.3432 2.66602 16.2285 2.66602 19.9997V21.3331C2.66602 25.1043 2.66602 26.9899 3.83759 28.1615C5.00916 29.3331 6.89478 29.3331 10.666 29.3331H21.3327C25.1039 29.3331 26.9895 29.3331 28.1611 28.1615C29.3327 26.9899 29.3327 25.1043 29.3327 21.3331V19.9997C29.3327 16.2285 29.3327 14.3432 28.1611 13.1716C26.9895 12 25.1039 12 21.3327 12Z",
    fill: "#F9AA2A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportIcon);
export default __webpack_public_path__ + "static/media/importIcon.2554dfd0560137727093d389865e2bae.svg";
export { ForwardRef as ReactComponent };